module.exports = __webpack_public_path__ + "static/media/warning-blue-super.c23d2c30.svg";